import { Button, ConfirmDialog, Input, Label, toast, useConfirm } from '@estac1/ui';
import { useMutation } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';
import { ApiError, api } from '../../lib/api.js';

/** `YYYY-MM-DD` em `DD/MM/AAAA`. */
export const br = (ymd: string | null) => (ymd ? ymd.split('-').reverse().join('/') : '-');

/**
 * Período grátis até uma data (#710): mexe no Asaas e no estacionamento juntos.
 * `onDone` atualiza as telas que mostram a cobrança e o status.
 */
export const FreePeriodForm = ({ lotId, onDone }: { lotId: string; onDone: () => void }) => {
  const [until, setUntil] = useState('');
  const confirm = useConfirm();
  const free = useMutation({
    mutationFn: (date: string) =>
      api.request<{ nextDueDate: string | null; removedCharges: number }>(
        `/v1/admin/clients/${lotId}/free-period`,
        { method: 'POST', json: { until: date } },
      ),
    onSuccess: (data, date) => {
      const removed =
        data.removedCharges === 1
          ? '1 cobrança removida'
          : `${data.removedCharges} cobranças removidas`;
      const next = data.nextDueDate ? ` A próxima cobrança vence em ${br(data.nextDueDate)}.` : '';
      toast.success(`Grátis até ${br(date)}, com ${removed}.${next}`);
      setUntil('');
      onDone();
    },
    onError: (err) =>
      toast.error(err instanceof ApiError ? err.message : 'Não foi possível dar o período grátis.'),
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (until) confirm.confirm(() => free.mutateAsync(until));
  };

  return (
    <>
      <form
        onSubmit={onSubmit}
        className="flex flex-wrap items-end gap-2 border-t border-border pt-4"
      >
        <div className="space-y-1">
          <Label htmlFor="free-until">Grátis até</Label>
          <Input
            id="free-until"
            type="date"
            value={until}
            onChange={(e) => setUntil(e.target.value)}
          />
        </div>
        <Button type="submit" disabled={!until || free.isPending}>
          Dar período grátis
        </Button>
      </form>
      <p className="text-xs text-muted-fg">
        O estacionamento fica em teste até o fim do dia escolhido. As cobranças em aberto saem do
        Asaas sem aviso ao cliente, a próxima cobrança da assinatura passa para esse dia e a
        abertura de tickets é liberada na hora.
      </p>
      <ConfirmDialog
        {...confirm.dialogProps}
        title={`Grátis até ${br(until)}?`}
        description="As cobranças em aberto saem do Asaas sem aviso ao cliente, a próxima cobrança da assinatura passa para esse dia e o estacionamento fica em teste até lá, com a abertura de tickets liberada."
        confirmLabel="Dar período grátis"
        pending={free.isPending}
      />
    </>
  );
};
